import React, { Component } from "react";
import DocumentsForm from "../DocumentsForm/DocumentsForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : LicensesPage
Description : Compoente que alberga el formulario de Licenses definido en el directorio de componentes
Date Autor Modification
================================================================================
29/09/2022 Santiago Coca - Se define el componente
================================================================================ */

class DocumentsPage extends Component {
    render() {
        return (
            <div>
                <DocumentsForm />
            </div>
        )
    }
}

export default DocumentsPage;